import ReactDOM from "react-dom"
import AspCentresContainer from "../../aspcentres/components/AspCentresContainer";

const htmlElement = document.getElementById("aspCentres");

ReactDOM.render(
    <AspCentresContainer 
        apiUrl={htmlElement.dataset.apiurl}
        showCountryDropDown={htmlElement.dataset.showcountrydropdown}
        showPagination={htmlElement.dataset.showpagination}
        paginationItemsPerPage={htmlElement.dataset.paginationitemsperpage}
        paginationInitialPage={htmlElement.dataset.paginationinitialpage}
    />, htmlElement)